// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1k55w","select":"Header_select__fO827","clinic":"Header_clinic__eWUDJ"};